import { convertUser } from '@nextforce/api'
import { isEmpty } from 'lodash'
import { GoldStarLogs, GoldStarUserLogs } from '../types'
import { GoldStarLogsResponse, GoldStarUserLogsResponse } from './response'

export function convertGoldStarUserLogsResponse(
  response: GoldStarUserLogsResponse
): GoldStarUserLogs {
  if (isEmpty(response)) return {}
  return {
    allocatedStarCount: response?.allocated_star_count ?? undefined,
    previousMonthStarBalance:
      response?.previous_month_star_balance ?? undefined,
    goldStarUserLogs:
      response?.gold_star_log?.map(convertGoldStarUserLog) ?? [],
  }
}

export function convertGoldStarUserLog(log: GoldStarLogsResponse) {
  return {
    transactionId: log?.transaction_id ?? undefined,
    fromUser: log?.from_user ? convertUser(log?.from_user) : undefined,
    user: log?.user ? convertUser(log?.user) : undefined,
    starCount: log?.star_count ?? undefined,
    companyId: log.companyId,
    type: convertType(log?.type),
    changedAt: log.changed_at,
  }
}

function convertType(type: GoldStarLogsResponse['type']): GoldStarLogs['type'] {
  switch (type) {
    case 'AWARDED':
      return 'awarded'
    case 'TRANSFERRED':
      return 'transferred'
    case 'ALLOCATED':
      return 'allocated'
    case 'END_OF_MONTH_STAR_BALANCE':
      return 'end_of_month_star_balance'
    case 'DEACTIVATED':
      return 'deactivated'
  }
}
